<script>
    import { onMount } from "svelte";
    import {communicationError} from "../lib/api"
    import * as crypflo from "../lib/crypto";

    /** @import {Session} from "../lib/types" */

    let loginName = $state("");

    async function login() {
        if (!loginName) return;

        const ekeModulo = crypflo.chooseRandom(crypflo.basePrimes);
        const ekePrivate = crypflo.randomUInt64();
        const ekeBase = crypflo.randomUInt64();
        const ekeCompound = crypflo.modularExponentiation(ekeBase, ekePrivate, ekeModulo);

        const exchangeResp = await fetch("/session", {
            method: "POST",
            headers: [["Content-Type", "application/json"]],
            body: JSON.stringify({
                modulo: ekeModulo.toString(),
                base: ekeBase.toString(),
                compound: ekeCompound.toString(),
            })
        });

        if (!exchangeResp.ok) communicationError("Echec de l'échange de clef : " + await exchangeResp.text());

        const respBody = await exchangeResp.json();
        const newKey = crypflo.modularExponentiation(BigInt(respBody.compound), ekePrivate, ekeModulo).toString(16).padStart(16, "0").toUpperCase();
        /** @type {Session} */
        const session = {
            hash: crypflo.decrypt(respBody.sessionHash, newKey),
            key: newKey
        };
        localStorage.setItem("session", JSON.stringify(session));

        const loginResp = await fetch("/login", {
            method: "POST",
            headers: [["Content-Type", "application/json"]],
            body: JSON.stringify({
                hash: session.hash,
                body: crypflo.encrypt(loginName, session.key)
            })
        });

        if (loginResp.status == 401) communicationError("Code inconnu");
        if (!loginResp.ok) communicationError("Erreure lors de l'authentification : " + await loginResp.text());

        window.location = "/home";
    }
    
    onMount(localStorage.clear);
</script>

<header>
    <img style:height="2em" src="./favicon.png" alt="" />
    <h1>Letas</h1>
</header>

<form class="gradient" onsubmit={e=>{e.preventDefault(); login()}}>
    <input
        type="password"
        style:width="12em"
        placeholder="Code"
        required
        bind:value={loginName}
    />
    <button type="submit">󰍂&thinsp;</button>
</form>

<style>
    h1 {
        flex-grow: 1;
        text-align: center;
    }
    form {
        width: max-content;

        margin: auto;
        margin-top: 5em;
        border-radius: 1em;
        padding: 1em;
    }
</style>
